import React from 'react';

export type DashboardEvalStatusCode = '1' | '2' | '3';

const EVAL_STATUS_LABELS: Record<DashboardEvalStatusCode, string> = {
  '1': '평가계획',
  '2': '평가중',
  '3': '평가완료',
};

const EVAL_STATUS_TONE: Record<DashboardEvalStatusCode, 'is-plan' | 'is-progress' | 'is-done'> = {
  '1': 'is-plan',
  '2': 'is-progress',
  '3': 'is-done',
};

export function parseDashboardEvalStatusCode(
  raw: string | null | undefined
): DashboardEvalStatusCode | null {
  const v = (raw ?? '').trim();
  if (v === '1' || v === '2' || v === '3') return v;
  return null;
}

/** 대시보드 수업 블럭·미니모달용 평가 상태 필 배지 */
export function DashboardLessonEvalStatusBadge({
  code,
  label,
  className = '',
}: {
  code: string | null | undefined;
  label?: string | null;
  className?: string;
}): React.ReactElement | null {
  const parsed = parseDashboardEvalStatusCode(code);
  if (!parsed) return null;
  const text = (label ?? '').trim() || EVAL_STATUS_LABELS[parsed];
  return (
    <span
      className={['cp-dash-lesson-eval-status-badge', EVAL_STATUS_TONE[parsed], className]
        .filter(Boolean)
        .join(' ')}
      title={text}
    >
      {text}
    </span>
  );
}
